import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Col, Form, Row } from 'react-bootstrap'
import { Node } from 'reactflow'
import { BaseNodeData } from '../../base/types'
import { NodeTypes } from '../../../../../../shared/models/rule-node'
import Input from '../../../../../../components/form/Input'

export interface GenerateReportConfiguration {
  name: string
  isDebugMode: boolean
  template: string
  outputPdf: boolean
  outputHtml: boolean
}

interface GenerateReportFormProps {
  onSubmit: (
    data: Node<
      BaseNodeData<GenerateReportConfiguration>,
      NodeTypes.FLOW_GENERATE_REPORT
    >
  ) => void
  defaultValues: Node<
    BaseNodeData<GenerateReportConfiguration>,
    NodeTypes.FLOW_GENERATE_REPORT
  >
}

const GetOriginTelemetryForm = ({
  onSubmit,
  defaultValues,
}: GenerateReportFormProps) => {
  const form = useForm<
    Node<
      BaseNodeData<GenerateReportConfiguration>,
      NodeTypes.FLOW_GENERATE_REPORT
    >
  >({
    defaultValues,
  })
  const {
    handleSubmit,
    reset,
    register,
    watch,
    formState: { errors },
  } = form
  const { configuration } = watch('data')
  return (
    <FormProvider {...form}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)} id={'form_rule_node'}>
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={register('data.name', {
                required: 'Le nom est obligatoire',
              })}
              label={'Nom'}
              error={errors.data?.name ? errors.data?.name : undefined}
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} md={12}>
            <Form.Check
              type="switch"
              label="Debug Mode ?"
              {...register('data.isDebugMode')}
            />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} lg={6} md={12}>
            <Form.Check
              type="switch"
              label="Save PDF file"
              {...register('data.configuration.outputPdf')}
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} md={12}>
            <Form.Check
              type="switch"
              label="Get HTML in metadata"
              {...register('data.configuration.outputHtml')}
            />
          </Form.Group>
        </Row>
        <Row>
          <Input
            type={'textarea'}
            register={register('data.configuration.template', {
              required: 'Le template est obligatoire',
            })}
          />
        </Row>
      </Form>
    </FormProvider>
  )
}

export default GetOriginTelemetryForm
